module.exports = __webpack_public_path__ + "img/brown-carpet-grass-09.63e6f07a.png";